import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Hero from './components/Hero';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import DoctorSupervision from './components/DoctorSupervision';
import SupervisionDetail from './components/SupervisionDetail';
import CTA from './components/CTA';
import Footer from './components/Footer';
import SEOHead from '../../components/SEOHead';
import CallScheduleModal from '../../components/feature/CallScheduleModal';

export default function Home() {
  const [isCallModalOpen, setIsCallModalOpen] = useState(false);
  const siteUrl = import.meta.env.VITE_SITE_URL || '';

  const schema = [
    {
      "@context": "https://schema.org",
      "@type": ["MedicalBusiness", "Dentist"],
      "@id": `${siteUrl}/#medicalbusiness`,
      "name": "Plexus Alliance",
      "description": "World-class dental care in Turkey with independent doctor supervision. Save up to 70% on dental implants, veneers, smile makeovers, and more at JCI-accredited clinics in Istanbul.",
      "url": siteUrl,
      "logo": `${siteUrl}/favicon.svg`,
      "image": `${siteUrl}/favicon.svg`,
      "telephone": "+90-531-614-8445",
      "email": "info@plexusalliance.com",
      "medicalSpecialty": "Dentistry",
      "priceRange": "$$",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Istanbul",
        "addressRegion": "TR-34",
        "addressCountry": "TR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "41.008240",
        "longitude": "28.978359"
      },
      "areaServed": {
        "@type": "Country",
        "name": "Worldwide"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+90-531-614-8445",
        "contactType": "Patient Services",
        "areaServed": "Worldwide",
        "availableLanguage": ["English", "Turkish", "Arabic", "German", "French", "Spanish", "Italian", "Russian"]
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Dental Treatments",
        "itemListElement": [
          { "@type": "Offer", "itemOffered": { "@type": "MedicalProcedure", "name": "Dental Implants" } },
          { "@type": "Offer", "itemOffered": { "@type": "MedicalProcedure", "name": "Porcelain Veneers" } },
          { "@type": "Offer", "itemOffered": { "@type": "MedicalProcedure", "name": "Smile Makeover" } },
          { "@type": "Offer", "itemOffered": { "@type": "MedicalProcedure", "name": "Teeth Whitening" } },
          { "@type": "Offer", "itemOffered": { "@type": "MedicalProcedure", "name": "All-on-4 Implants" } }
        ]
      },
      "sameAs": [
        "https://wa.me/message/OAKDCTBVIML6F1"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": `${siteUrl}/#organization`,
      "name": "Plexus Alliance",
      "url": siteUrl,
      "logo": {
        "@type": "ImageObject",
        "url": `${siteUrl}/favicon.svg`
      },
      "description": "Doctor-supervised dental tourism in Istanbul, Turkey. Save up to 70% on dental implants, veneers, smile makeovers and more at JCI-accredited clinics.",
      "telephone": "+90-531-614-8445",
      "email": "info@plexusalliance.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Istanbul",
        "addressRegion": "TR-34",
        "addressCountry": "TR"
      },
      "sameAs": [
        "https://wa.me/message/OAKDCTBVIML6F1"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      "url": siteUrl,
      "name": "Plexus Alliance",
      "description": "Doctor-supervised dental care in Istanbul, Turkey. Save up to 70% on implants, veneers, smile makeovers and more.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${siteUrl}/treatments`
        },
        "query-input": "required name=search_term_string"
      }
    }
  ];

  const handleBookClick = () => {
    window.REACT_APP_NAVIGATE('/book-treatment');
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Plexus Alliance | Doctor-Supervised Dental Care in Turkey — Save Up to 70%"
        description="Get world-class dental treatments in Istanbul, Turkey at up to 70% lower cost. Independent doctor supervision, JCI-accredited clinics, full transparency. Implants, veneers, smile makeovers & more."
        keywords="dental tourism Turkey, dental implants Istanbul, affordable dental care Turkey, supervised dental treatment, JCI dental clinic Istanbul, veneers Turkey, smile makeover Turkey"
        canonical={siteUrl}
        schema={schema}
      />
      <Navigation />
      <Hero onBookClick={handleBookClick} onTalkClick={() => setIsCallModalOpen(true)} />
      <Services />
      <HowItWorks />
      <DoctorSupervision />
      <SupervisionDetail onBookClick={handleBookClick} />
      <CTA onBookClick={handleBookClick} />
      <Footer onBookClick={handleBookClick} />
      <CallScheduleModal isOpen={isCallModalOpen} onClose={() => setIsCallModalOpen(false)} />
    </div>
  );
}
